import { ThemeProvider } from '@mui/material/styles';
import { theme as defaultTheme } from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { Header, MobileHeader } from './components/Header';
import { Footer } from './components/Footer';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import './App.css';
import { Navigation } from './components/Navigation';
import { useResponsive } from './hooks/useResponsive';

const updateDate = '01/19/2022 @ 1436';

function App() {
  const { isMobile } = useResponsive();

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={defaultTheme}>
        <Box display='grid' gridTemplateRows='auto 1fr auto' height='100vh'>
          {isMobile ? (
            <MobileHeader updateDate={updateDate} />
          ) : (
            <Header updateDate={updateDate} />
          )}
          <main>
            <Box sx={{ paddingTop: isMobile ? '0px' : '180px' }}>
              <Navigation />
              <Outlet />
            </Box>
          </main>
          <Footer />
        </Box>
      </ThemeProvider>
    </>
  );
}

export default App;
